<style scoped>
.cross-apn-container {
  position: relative;
}

.cross-apn {
  bottom: 0;
  position: absolute;
}
</style>

<template>
  <b-row class="m-3">
    <b-col md="9">
      <b-row>
        <b-col md="8">
          <div><strong>Address</strong>: {{ cross.address }}</div>
        </b-col>
        <b-col md="4">
          <div><strong>Unit</strong>: {{ cross.unit || '-' }}</div>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <div><strong>City</strong>: {{ cross.city }}</div>
        </b-col>
        <b-col>
          <div><strong>State</strong>: {{ cross.state }}</div>
        </b-col>
        <b-col>
          <div><strong>Zip Code</strong>: {{ cross.zipCode }}</div>
        </b-col>
      </b-row>
    </b-col>
    <b-col md="3" class="left-border cross-apn-container">
      <div class="cross-apn">
        <strong>APN:</strong> {{ cross.apn || '-'  }}
      </div>
    </b-col>
  </b-row>
</template>


<script>
export default {
  props: {
    cross: Object,
    required: true,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/properties/CrossDisplay.vue